export default __webpack_public_path__ + "img/introduce.81a5100c.png";